/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-builder/index.js to modify the generation of this file.

import { ComponentBuilder } from '@sitecore-jss/sitecore-jss-react';

import ArticleList from '../components/ArticleList';
import Card from '../components/Card';
import Cards from '../components/Cards';
import CenteredText from '../components/CenteredText';
import ColorCard from '../components/ColorCard';
import ColorCards from '../components/ColorCards';
import CookieConsentBanner from '../components/CookieConsentBanner';
import CustomInsertHtml from '../components/CustomInsertHtml';
import EntranceSingleLeft from '../components/EntranceSingleLeft';
import EntranceSinglePopoutLeft from '../components/EntranceSinglePopoutLeft';
import EntranceSinglePopoutRight from '../components/EntranceSinglePopoutRight';
import EntranceSingleRight from '../components/EntranceSingleRight';
import ExpandedTextAccordion from '../components/ExpandedTextAccordion';
import ExpandedTextAccordionItem from '../components/ExpandedTextAccordionItem';
import FacebookPixel from '../components/FacebookPixel';
import Footer from '../components/Footer';
import FormCallMe from '../components/FormCallMe';
import FormCprUpload from '../components/FormCprUpload';
import FormCvrUpload from '../components/FormCvrUpload';
import FormGdpr from '../components/FormGdpr';
import FormNemKonto from '../components/FormNemKonto';
import FormPpi from '../components/FormPpi';
import FormUnsubscribe from '../components/FormUnsubscribe';
import Header from '../components/Header';
import Headline from '../components/Headline';
import HeroDefault from '../components/HeroDefault';
import HeroFrontpage from '../components/HeroFrontpage';
import HeroFrontpageColumnItem from '../components/HeroFrontpageColumnItem';
import HeroProduct from '../components/HeroProduct';
import HtmlRenderer from '../components/HtmlRenderer';
import ImageHeader from '../components/ImageHeader';
import ImageLeft from '../components/ImageLeft';
import ImageRight from '../components/ImageRight';
import LoanCalculator from '../components/LoanCalculator';
import LoanCalculatorInputsOnly from '../components/LoanCalculatorInputsOnly';
import NewsListHorizontal from '../components/NewsListHorizontal';
import NewsListHorizontalItem from '../components/NewsListHorizontalItem';
import NewsListVertical from '../components/NewsListVertical';
import NewsListVerticalItem from '../components/NewsListVerticalItem';
import ProductFeature from '../components/ProductFeature';
import RatesTables from '../components/RatesTables';
import RichText from '../components/RichText';
import ShortcutLink from '../components/ShortcutLink';
import SurveyInit from '../components/SurveyInit';
import Table from '../components/Table';
import TextAccordion from '../components/TextAccordion';
import TextAccordionItem from '../components/TextAccordionItem';

const components = new Map();

components.set('ArticleList', ArticleList);
components.set('Card', Card);
components.set('Cards', Cards);
components.set('CenteredText', CenteredText);
components.set('ColorCard', ColorCard);
components.set('ColorCards', ColorCards);
components.set('CookieConsentBanner', CookieConsentBanner);
components.set('CustomInsertHtml', CustomInsertHtml);
components.set('EntranceSingleLeft', EntranceSingleLeft);
components.set('EntranceSinglePopoutLeft', EntranceSinglePopoutLeft);
components.set('EntranceSinglePopoutRight', EntranceSinglePopoutRight);
components.set('EntranceSingleRight', EntranceSingleRight);
components.set('ExpandedTextAccordion', ExpandedTextAccordion);
components.set('ExpandedTextAccordionItem', ExpandedTextAccordionItem);
components.set('FacebookPixel', FacebookPixel);
components.set('Footer', Footer);
components.set('FormCallMe', FormCallMe);
components.set('FormCprUpload', FormCprUpload);
components.set('FormCvrUpload', FormCvrUpload);
components.set('FormGdpr', FormGdpr);
components.set('FormNemKonto', FormNemKonto);
components.set('FormPpi', FormPpi);
components.set('FormUnsubscribe', FormUnsubscribe);
components.set('Header', Header);
components.set('Headline', Headline);
components.set('HeroDefault', HeroDefault);
components.set('HeroFrontpage', HeroFrontpage);
components.set('HeroFrontpageColumnItem', HeroFrontpageColumnItem);
components.set('HeroProduct', HeroProduct);
components.set('HtmlRenderer', HtmlRenderer);
components.set('ImageHeader', ImageHeader);
components.set('ImageLeft', ImageLeft);
components.set('ImageRight', ImageRight);
components.set('LoanCalculator', LoanCalculator);
components.set('LoanCalculatorInputsOnly', LoanCalculatorInputsOnly);
components.set('NewsListHorizontal', NewsListHorizontal);
components.set('NewsListHorizontalItem', NewsListHorizontalItem);
components.set('NewsListVertical', NewsListVertical);
components.set('NewsListVerticalItem', NewsListVerticalItem);
components.set('ProductFeature', ProductFeature);
components.set('RatesTables', RatesTables);
components.set('RichText', RichText);
components.set('ShortcutLink', ShortcutLink);
components.set('SurveyInit', SurveyInit);
components.set('Table', Table);
components.set('TextAccordion', TextAccordion);
components.set('TextAccordionItem', TextAccordionItem);

const componentBuilder = new ComponentBuilder({ components });

export const componentFactory = componentBuilder.getComponentFactory();
